<div class="first-value">{{ firstValue }}</div>
<div class="second-value">{{ secondValue }}</div>
